import * as React from 'react';

import {useFocusWithin} from '@react-aria/interactions';

type Props = {
    sectionId: string;
    onFocus: (sectionId: string) => void;
    onBlur?: (sectionId: string) => void;
    shouldSetOnHover?: boolean;
    children: React.ReactNode;
};

export function PreviewableSection(props: Props) {
    const {sectionId, onFocus, onBlur, shouldSetOnHover = false, children} = props;

    const {focusWithinProps} = useFocusWithin({
        onFocusWithin: () => onFocus(sectionId),
        onBlurWithin: () => onBlur && onBlur(sectionId),
    });

    const hoverProps = shouldSetOnHover
        ? {
              onMouseEnter: () => onFocus(sectionId),
              onMouseLeave: () => onBlur && onBlur(sectionId),
          }
        : {};

    return (
        <div {...focusWithinProps} {...hoverProps}>
            {children}
        </div>
    );
}
